import {
    NameStyled,
    NameTitleStyled,
    VariantColorStyled,
    VariantStyled,
    VariantTextStyled,
} from './ItemInfo/ItemInfo.style';
import { isB2bDomain } from 'helpers/isDomainLocale';
import { useDomainConfig } from 'hooks/useDomainConfig';
import useTranslation from 'next-translate/useTranslation';
import tinycolor from 'tinycolor2';
import { CartItemType } from 'types/cart';

type ItemNameProps = {
    item: CartItemType;
};

const TEST_IDENTIFIER = 'pages-cart-list-item-iteminfo-';

export const ItemName: FC<ItemNameProps> = ({ item }) => {
    const { t } = useTranslation();
    const domainConfig = useDomainConfig();

    return (
        <NameStyled data-testid={TEST_IDENTIFIER + 'name'}>
            <NameTitleStyled type="product" href={item.product.slug}>
                <>
                    {isB2bDomain(domainConfig) && <span className="pr-4 font-bold">{item.product.catalogNumber}</span>}
                    <span>{item.product.name}</span>
                    {item.product.currentColorVariant && item.product.colorVariants.length && (
                        <VariantStyled>
                            {t('Color')}:
                            <VariantColorStyled
                                isLightColor={tinycolor(item.product.currentColorVariant.value).isLight()}
                                colorValue={item.product.currentColorVariant.value}
                                colorImage={item.product.currentColorVariant.colorImage}
                            />
                            <VariantTextStyled>{item.product.currentColorVariant.name}</VariantTextStyled>
                        </VariantStyled>
                    )}
                </>
            </NameTitleStyled>
        </NameStyled>
    );
};
